import { AfterViewInit, Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Modal } from 'bootstrap';
import { BagPaymentListTableSummaryComponent } from './bag-payment-list-table-summary/bag-payment-list-table-summary.component';

@Component({
	selector: 'app-bag-payment-list-table',
	templateUrl: './bag-payment-list-table.component.html',
	styleUrls: ['./bag-payment-list-table.component.scss'],
})
export class BagPaymentListTableComponent implements AfterViewInit, OnChanges {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(BagPaymentListTableSummaryComponent)
	BagPaymentListTableSummaryComponent: BagPaymentListTableSummaryComponent;
	@Input() elements;
	@Input() tableColumns = [];
	protected tableKeys: string[];
	protected tableShowOptions = false;
	protected module = '';
	protected itemsBeforeDataLoad = 0;

	matData = new MatTableDataSource<any>();
	viewIsSet = false;
	showTable = true;
	showColumns: string[] = [];
	settings = {
		hiddenColumns: [],
	};

	ngAfterViewInit() {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
	}

	ngOnChanges(): void {
		if (!this.elements) {
			return;
		}
		this.settingsLoad();
		this.loadData();
	}

	protected loadData(): void {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.matData.data = this.elements;
		this.convertData(this.matData.data);
	}

	protected convertData(data): void {
		this.tableKeys = this.tableColumns.map((col) => col.id);
		this.tableKeys.push('editButton');
		this.tableKeys.push('columnShow');
		this.matData.data = data;
		this.settingsLoad();
		this.generateColumns();
	}

	protected generateColumns(): void {
		this.showColumns = this.tableKeys.filter((obj) => !this.settings.hiddenColumns.includes(obj));
	}

	protected showHideRow(itemId): void {
		if (!this.settings.hiddenColumns.includes(itemId)) {
			this.settings.hiddenColumns.push(itemId);
		} else {
			this.settings.hiddenColumns.splice(this.settings.hiddenColumns.indexOf(itemId), 1);
		}
		this.settingsSave();
		this.loadData();
		this.viewIsSet = this.settings.hiddenColumns && this.settings.hiddenColumns.length ? true : false;
	}

	private settingsSave(): void {
		localStorage.setItem('pageSettings-' + this.module, JSON.stringify(this.settings));
	}

	protected copy2Clipboard() {
		const col = [
			'payment',
			'posting',
			'status',
			'kind',
			'amount',
			'payer',
			'bankAccountPosting',
			'bankAccountIncoming',
			'reservation',
		];
		const rows = this.matData.data.map((row: any) => {
			const obj = {
				payment: row.payment,
				posting: row.posting,
				status: row.status,
				kind: row.kind,
				amount: row.amount,
				payer: row.payer,
				bankAccountPosting: row.bankAccountPosting,
				bankAccountIncoming: row.bankAccountIncoming,
				reservation: row.tableId.label,
			};

			return Object.assign([], obj, {
				...col.map((header) => obj[header]),
			});
		});
		const table = [col, ...rows];
		const csvData = table.map((row) => row.join(';')).join('\n');
		navigator.clipboard.writeText(csvData);
	}

	private settingsLoad(): void {
		if (!localStorage['pageSettings-' + this.module]) {
			return;
		}
		this.settings = JSON.parse(localStorage['pageSettings-' + this.module]);
		this.viewIsSet = this.settings.hiddenColumns && this.settings.hiddenColumns.length ? true : false;
	}

	protected dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('addModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	protected openDialog() {
		new Modal(document.getElementById('addModal')).show();
	}
}
